import { apiFetch, tokens, type TokenPair } from "./client.ts";

export interface CurrentUser {
  id: string;
  account_id: string;
  email: string;
  full_name: string;
  phone_e164: string | null;
  role: "admin" | "dispatcher" | "technician";
  preferred_locale: string;
  totp_enabled: boolean;
  is_active: boolean;
  mfa_verified: boolean;
}

export async function status(): Promise<{ setup_required: boolean }> {
  return apiFetch<{ setup_required: boolean }>("/auth/status");
}

export async function setup(payload: {
  account_name: string;
  account_slug: string;
  admin_email: string;
  admin_full_name: string;
  password: string;
  confirm_password: string;
}): Promise<TokenPair> {
  const data = await apiFetch<TokenPair>("/auth/setup", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  tokens.set(data);
  return data;
}

export async function login(payload: {
  email: string;
  password: string;
  totp_code?: string;
  device_label?: string;
}): Promise<TokenPair> {
  const data = await apiFetch<TokenPair>("/auth/token", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!data.mfa_required) tokens.set(data);
  return data;
}

export async function mfaVerify(challenge: string, code: string, trustDevice = false): Promise<TokenPair> {
  const data = await apiFetch<TokenPair>("/auth/mfa/verify", {
    method: "POST",
    body: JSON.stringify({
      challenge_token: challenge,
      totp_code: code,
      trust_device: trustDevice,
      device_label: navigator.userAgent.slice(0, 200),
    }),
  });
  tokens.set(data);
  return data;
}

export async function logout(): Promise<void> {
  if (tokens.refresh) {
    try {
      await apiFetch("/auth/logout", {
        method: "POST",
        body: JSON.stringify({ refresh_token: tokens.refresh }),
      });
    } catch {
      /* ignore */
    }
  }
  tokens.clear();
}

export async function me(): Promise<CurrentUser> {
  return apiFetch<CurrentUser>("/auth/me");
}

export async function startSso(): Promise<{ authorization_url: string }> {
  return apiFetch<{ authorization_url: string; state: string }>("/auth/sso/google/start");
}
